var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 mb-2"},[_c('div',{staticStyle:{"margin":"0 auto","text-align":"center"}},[_c('component-advertisement')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }